import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ArrowLeft, UserCircle } from "lucide-react";
import UserInfo from "./UserInfo";
import "./ViewUser.css";

const ViewUser = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const userData = location.state?.data;

  return (
    <div style={{ margin: "8px", fontFamily: "'Poppins', 'Segoe UI', sans-serif" }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@500;600;700;800&display=swap');`}</style>
      <div className="usv-header-banner">
        <button type="button" className="usv-back-btn" onClick={() => navigate(-1)} aria-label="Back">
          <ArrowLeft size={16} />
        </button>
        <span className="usv-header-icon">
          <UserCircle size={14} color="#fff" />
        </span>
        <div>
          <div className="usv-header-title">View User</div>
          <div className="usv-header-subtitle">User account and access details</div>
        </div>
      </div>
      <UserInfo userData={userData} />
    </div>
  );
};

export default ViewUser;
